import FontFaceObserver from 'fontfaceobserver'

export default () => {
	const $html = document.getElementsByTagName('html')[0]
	const highlight = new FontFaceObserver('Felix Titling MT W00 Regular')
	const heading = new FontFaceObserver('GoudyOldStyleBTW01-Roma')
	const light = new FontFaceObserver('Gill Sans W01 Light')
	const book = new FontFaceObserver('Gill Sans W04 Book')
	const medium = new FontFaceObserver('Gill Sans W01 Medium')

	Promise.all([
		highlight.load(),
		heading.load(),
		light.load(),
		book.load(),
		medium.load()
	])
		.then(() => $html.classList.add('fonts-loaded'))
		.catch(() => $html.classList.add('fonts-failed'))
}
